import { Vue, Component, Watch } from 'vue-property-decorator';
import { Getter, Mutation } from 'vuex-class';
import DefaultScreenContent from '@/components/DefaultScreenContent.vue';
import EditableTable from '@/../bower_components/teknisavuecomponents/components/grids/EditableTable.vue';
import Periodo from '@/../bower_components/teknisavuecomponents/assets/interfaces/Periodo';
import SnackbarUtils from '@/../bower_components/teknisavuecomponents/assets/utils/SnackbarUtils';
import HttpRequest from '@/../bower_components/teknisavuecomponents/assets/utils/HttpRequest';
import TkDateRange from '@/components/TkRange.vue';
import Util from '@/../bower_components/teknisavuecomponents/assets/utils/Util';
import DateUtil from '@/../bower_components/teknisavuecomponents/assets/utils/DateUtil';
import DialogUtils from '@/../bower_components/teknisavuecomponents/assets/utils/DialogUtils';
import CommonRequests from '@/assets/ts/controller/CommonRequests';
import User from '@/../bower_components/teknisavuecomponents/assets/interfaces/User';
import { ActionPermissao, ControleAcessoController, ControleAcessoWrapper } from '@/assets/ts/controller/ControleAcessoController';

@Component({
  name: 'ProgramacaoFerias',
  components: {
    DefaultScreenContent,
    EditableTable,
    TkDateRange,
  }
})
export default class ProgramacaoFerias extends Vue {
  // #region [ DATA ]
  private view = {
    title: 'Programação de Férias',
  };

  private key = 0;

  private limiteDias: string = null;

  private backup: any[] = null;
 
  private grid = {
    mode: 'edit',
    readonly: true,
    dataSource: {
      route: 'getProgramacaoFerias',
      reloadOnCreation: true,
      filters: {
        NRORG: this.$store.getters.user.nrorg,
        NRESTRUTURAM: this.$store.getters.estruturaGerencialAtual.NRESTRUTURAM,
        NRPERIODOAPURACAO: this.$store.getters.periodoDemonstrativoAtual.NRPERIODOAPURACAO
      },
    },
    alterableFields: [
      'DTINIPREVISAO',
      'DTFINPREVISAO',
      'QTDIASPREVISAO',
      'QTABONOPREVISAO',
    ],
    columns: [
      {
        value: 'NOMEFUNCI',
        text: 'Nome',
        type: 'text',
        readonly: true,
      },
      {
        value: 'NMSITUFUNCH',
        text: 'Situação Funcional',
        type: 'text',
        readonly: true,
      },
      {
        value: 'OCUPACAO',
        text: 'Ocupação',
        type: 'text',
        readonly: true,
      },
      {
        value: 'ADMISSAO',
        text: 'Admissão',
        type: 'text',
        readonly: true,
      },
      {
        value: 'PERIODOAQUIS',
        text: 'Período Aquisitivo',
        type: 'text',
        readonly: true,
        width: '200px',
      },
      {
        value: 'ULTGOZOFERIAS',
        text: 'Últimas Férias',
        type: 'text',
        readonly: true,
        width: '200px',
      },
      {
        value: 'DIAS_GOZO',
        text: 'Dias Gozo',
        type: 'text',
        readonly: true,
      },
      {
        value: 'DIAS_RESTANTE_GOZO',
        text: 'Dias Rest.',
        type: 'text',
        readonly: true,
      },
      {
        value: 'QTFALTASPERIODO',
        text: 'Dias Faltas',
        type: 'text',
        readonly: true,
      },
      {
        value: 'QTDIAAFASTAMENT',
        text: 'Dias Afastado',
        type: 'text',
        readonly: true,
      },
      {
        value: 'DTLIMITE',
        text: 'Limite',
        type: 'text',
        readonly: true,
      },
      {
        value: 'DTINIPREVISAO',
        text: 'Dt. Início Previsão',
        type: 'date',
        width: '150px',
      },
      {
        value: 'QTDIASPREVISAO',
        text: 'Qtde. Dias',
        type: 'number',
        width: '80px',
      },
      {
        value: 'DTFINPREVISAO',
        text: 'Dt. Final Previsão',
        type: 'date',
        width: '150px',
        readonly: true,
      },
      {
        value: 'QTABONOPREVISAO',
        text: 'Abono',
        type: 'number',
        width: '80px',
      },
    ],
    loading: {
      isLoading: false,
    },
    rowActions: [],
    toolbar: {
      actions: [
        'reload',
        {
          icon: 'mdi-content-save',
          name: 'saveProgramacaoFerias',
          label: 'Salvar',
          returnEditedRows: true,
          onClick: this.saveProgramacaoFerias
        },
        {
          icon: 'mdi-cancel',
          name: 'cancelProgramacaoFerias',
          label: 'Cancelar Alterações',
          returnEditedRows: true,
          onClick: this.cancelProgramacaoFerias
        },
      ]
    },
    triggers: {
      reload: 0,
      contentReload: 0,
    },
    saveData: {
      save: this.saveProgramacaoFerias,
      route: 'setProgramacaoFerias',
    },
    events: {
      input: [
        this.updateFinalDate,
        this.initialDateValidation,
        this.validateLimiteDiasProg,
      ],
      change: [],
      onEnter: () => null,
    },
    styles: {
      rowStyles: {
        rowStyleFunction: this.rowStyleFunction,
      },
      ultFeriasMesAtual: {
        color: 'blue',
      },
      progFeriasConcorrentes: {
        color: 'red',
      },
    },
    actions: {
      clearAlterableFields: this.clearAlterableFields,
      isRowValid: this.daysValidation,
    },
    messages: {
      save: {
        success: 'A programação de férias foi salva com sucesso.',
        error: 'Houve um erro ao salvar a programação de férias.',
        noRowChange: 'Nenhum registro foi alterado.'
      },
    },
  };

  private messages = {
    input: {
      initialDateIsMoreRecentThanLimit: 'A data inicial é posterior à data limite.',
      daysOutOfBound: 'Os dias previstos estão fora dos limites estabelecidos para as férias',
      daysLeftOutOfBound: 'Os dias previstos ultrapassam os dias restantes para as férias',
    },
  };

  private columnsIndexes = {
    dataFinalPrevisao: 'DTFINPREVISAO',
    dataInicialPrevisao: 'DTINIPREVISAO',
    diasPrevisao: 'QTDIASPREVISAO',
    dataLimite: 'DTLIMITE',
    qntMaxFerias: 'QTDIASMAXFE',
    qntMinFerias: 'QTDIASMINFE',
    qntDiasRestantesFerias: 'DIAS_RESTANTE_GOZO',
    qntDiasAbono: 'QTABONOPREVISAO',
    nmVinculo: 'NOMEFUNCI',
    ultGozoFerias: 'ULTGOZOFERIAS',
  };

  private rows: any;
  // #endregion

  // #region [ STORE ]
  @Getter('periodoDemonstrativoAtual')
  private periodoDemonstrativoAtual: Periodo;

  @Getter('estruturaGerencialAtual')
  private estruturaGerencialAtual: any;

  private get user(): User {
    return this.$store.getters.user;
  }

  @Mutation('changeCurrentView')
  private changeCurrentView: (viewTitlw: string) => void;
  // #endregion

  // #region [ COMPUTED ]
  private get mappedRows() {
    const mappedRows = this.rows.map((row) => {
      const areDatesSelected = row[this.columnsIndexes.dataInicialPrevisao] && row[this.columnsIndexes.dataFinalPrevisao];

      return areDatesSelected ? { 
        INTERVALO_PREVISAO: row[this.columnsIndexes.dataInicialPrevisao] + ' a ' + row[this.columnsIndexes.dataFinalPrevisao],
        NOMEFUNCI: row.NOMEFUNCI,
      } : null;
    });

    return mappedRows;
  }

  private get rowsUpdated() {
    const rows = this.rows;

    return rows;
  }

  private get rowsFeriasConcorrentes() {

    const intervalIntersection = [];
    for (const mappedRow of this.mappedRows) {

      for (const comparedMappedRow of this.mappedRows) {
        if (mappedRow && comparedMappedRow && this.mappedRows.indexOf(mappedRow) !== this.mappedRows.indexOf(comparedMappedRow)) {

          const intersection = DateUtil.intervalIntersection(mappedRow.INTERVALO_PREVISAO, comparedMappedRow.INTERVALO_PREVISAO);
          if (Array.isArray(intersection) && intersection.length > 0) {

            // Verifica se ja foi inserida a relação
            const existingRelation = intervalIntersection.filter((row) => row.ROW2.NOMEFUNCI === mappedRow.NOMEFUNCI && row.ROW1.NOMEFUNCI === comparedMappedRow.NOMEFUNCI);

            if(Array.isArray(existingRelation) && existingRelation.length === 0) {
              intervalIntersection.push({
                ROW1: mappedRow,
                ROW2: comparedMappedRow
              });
            }

          }
        }
      }
    }

    const rowsWithIntersection = [];
    for (const intersection of intervalIntersection) {

      if (!rowsWithIntersection.includes(intersection.ROW1)) {
        rowsWithIntersection.push(
          intersection.ROW1,
        );
      }

      if (!rowsWithIntersection.includes(intersection.ROW2)) {
        rowsWithIntersection.push(
          intersection.ROW2,
        );
      }
    }

    return rowsWithIntersection;
  }
  // #endregion

  // #region [ LIFECYCLE ]
  private created() {
    this.changeCurrentView(this.view.title);
    this.getLimiteProgFerias();
  }

  private mounted() {
    if (!this.$store.getters.estruturaGerencialAtual) {
      const message = 'Não há unidades disponíveis!';
      SnackbarUtils.showMessage(message, 'alert', 5000);
    }
  }
  // #endregion

  // #region [ WATCHERS ]
  // Tirar watches e colocar como o filter como computed
  @Watch('periodoDemonstrativoAtual')
  private onChangePeriodo(newPeriodo: Periodo) {
    this.grid.dataSource.filters.NRPERIODOAPURACAO = newPeriodo.NRPERIODOAPURACAO;
    this.reloadGridData();
  }

  @Watch('estruturaGerencialAtual')
  private onChangeEstrutura(newEstrutura: any) {
    this.grid.dataSource.filters.NRESTRUTURAM = newEstrutura.NRESTRUTURAM;
    this.reloadGridData();
  }
  // #endregion

  // #region [ METHODS ]
  private reloadGridData() {
    // this.grid.triggers.contentReload++;
    this.grid.triggers.reload++;
  }

  private async saveProgramacaoFerias(rows) {
    // Component EditableTable is emmitting the event of click twice returning the first call with empty data and the second with the correct data.
    // the following if is to temporarially get over this
    if (rows) {
      try {
        if (Array.isArray(rows) && rows.length === 0) {
          SnackbarUtils.showMessage(this.grid.messages.save.noRowChange, SnackbarUtils.TYPE_ALERT);
          return;
        }
        
        // Validations
        // Put this as responsability of the grid?
        if (!this.grid.actions.isRowValid(rows)) {
          return;
        }

        try {
          this.validarControleAcesso(rows);
        } catch (error) {
          return;
        }

        await DialogUtils.show('Salvar Programação de Férias', 'Deseja salvar a programação de férias?');
        const response = await HttpRequest.post(this.grid.saveData.route, {
          requestType: 'Row',
          row: {
            NRORG: this.$store.getters.user.nrorg,
            CDOPERADOR: this.$store.getters.user.cdoperador,
            ROWS: {
              ...rows,
            }
          }
        });
  
        if (response.data.messages) {
          throw response.data.messages[0].message;
        }
  
        SnackbarUtils.showMessage(this.grid.messages.save.success, SnackbarUtils.TYPE_SUCCESS);
      } catch (err) {
        const errorMessage = typeof err === 'string' ? err : this.grid.messages.save.error;
        SnackbarUtils.showMessage(errorMessage, SnackbarUtils.TYPE_ERROR);
      }

      this.reloadGridData();

    }
    
  }

  private validarControleAcesso(rows: []) {
    const rowsAtualizar = rows.filter((row: any) => row.__backup_row.DTFINPREVISAO);
    const rowsCriar = rows.filter((row: any) => !row.__backup_row.DTFINPREVISAO);

    if(rowsAtualizar.length) {
      ControleAcessoController.validarPermissao(ActionPermissao.IDATUALIZAR);
    }

    if(rowsCriar.length) {
      ControleAcessoController.validarPermissao(ActionPermissao.IDCRIAR);
    }

  }

  private async cancelProgramacaoFerias(rows) {
    if(rows) {
      await DialogUtils.show('Cancelar Alterações', 'Deseja mesmo cancelar todas alterações?');

      rows.forEach(row => {
        this.clearAlterableFields(row);
      });
    }
  }

  private rowOnInput(row) {
    for (const actionOnInput of this.grid.events.input) {
      actionOnInput(row);
    }
  }

  private rowOnChange(row) {
    for (const actionOnChange of this.grid.events.change) {
      actionOnChange(row);
    }
  }

  private updateFinalDate(row) {
    const initialDate = row[this.columnsIndexes.dataInicialPrevisao];
    const days = parseInt(row[this.columnsIndexes.diasPrevisao], 10);

    if (!Util.isEmptyOrBlank(initialDate) && !(Util.isEmptyOrBlank(days) || isNaN(days))) {
      const finalDateGenerated = DateUtil.addDaysDate(initialDate, days, true);

      row[this.columnsIndexes.dataFinalPrevisao] = finalDateGenerated;
    } else {
      row[this.columnsIndexes.dataFinalPrevisao] = null;
    }

    if (Util.isEmptyOrBlank(initialDate)) {
      this.grid.actions.clearAlterableFields(row);
    }
  }

  // Não está funcionando corretamente
  private initialDateValidation(row) {
    const initialDate = row[this.columnsIndexes.dataInicialPrevisao];
    const limitDate = row[this.columnsIndexes.dataLimite];

    // Update backup row
    const rowCopy = Util.deepCopy(row.__backup_row);

    if (DateUtil.compareDates(initialDate, limitDate) === 1) {
      SnackbarUtils.showMessage(this.messages.input.initialDateIsMoreRecentThanLimit, SnackbarUtils.TYPE_ALERT);

      // Poderia não setar nada, só avisar e validar na hora de salvar
      setTimeout(() => {
        row[this.columnsIndexes.dataInicialPrevisao] = null;
        row[this.columnsIndexes.dataFinalPrevisao] = null;
      })
    }
      
  }

  // Essa validação vai ter que ser feita na hora de salvar
  private isRowSomaPrevisaoValida(row) {
    // colocar isso como validação do grid.
    let isRowValid = true;

    const qntMaxFerias = parseInt(row[this.columnsIndexes.qntMaxFerias]);
    const qntMinFerias = parseInt(row[this.columnsIndexes.qntMinFerias]);
    const qntDiasRestantesFerias = parseInt(row[this.columnsIndexes.qntDiasRestantesFerias]);
    const qntDiasAbono = parseInt(row[this.columnsIndexes.qntDiasAbono]);
    const nmVinculo = row[this.columnsIndexes.nmVinculo];
    
    const days = parseInt(row[this.columnsIndexes.diasPrevisao]);
    const totalDays = days + qntDiasAbono + (qntMaxFerias - qntDiasRestantesFerias);
    
    if (totalDays > qntMaxFerias || totalDays < qntMinFerias) {
      isRowValid = false;
      SnackbarUtils.showMessage(this.messages.input.daysOutOfBound + ` Vinculo: ${nmVinculo}`, SnackbarUtils.TYPE_ALERT);
    } else if (days > qntDiasRestantesFerias) {
      isRowValid = false;
      SnackbarUtils.showMessage(this.messages.input.daysLeftOutOfBound + ` Vinculo: ${nmVinculo}`, SnackbarUtils.TYPE_ALERT);
    }

    return isRowValid;
  }

  private daysValidation(rows): boolean {
    const isRowArray = Array.isArray(rows);

    if (!isRowArray) {
      rows = [rows];
    }

    let areRowValids = true;
    for (const row of rows) {
      const isRowValid = this.isRowSomaPrevisaoValida(row);
      areRowValids = isRowValid && areRowValids;
    }

    return areRowValids;
  }

  // Detecta quando o período das 'Últimas Férias' inclui dias do mês atual
  private ultimasFeriasMesAtualValidation(row) {
    const periodoUltGozoFerias = row[this.columnsIndexes.ultGozoFerias];

    const ultimasFeriasMesAtual = DateUtil.isActualMonthInInterval(periodoUltGozoFerias);
    
    if (ultimasFeriasMesAtual) {
      return this.grid.styles.ultFeriasMesAtual;
    }
    return {};
  }

  private feriasConcorrentesValidation(row) {
    const rowInRowsFeriasConcorrentes = this.rowsFeriasConcorrentes.filter((rowFeriasConcorrentes) => rowFeriasConcorrentes[this.columnsIndexes.nmVinculo] === row[this.columnsIndexes.nmVinculo]);
    const isRowAffected = Array.isArray(rowInRowsFeriasConcorrentes) && rowInRowsFeriasConcorrentes.length > 0;

    if (isRowAffected) {
      return this.grid.styles.progFeriasConcorrentes;
    }

    return {};
  }

  private rowStyleFunction(row) {
    const styles = [];
    const ultimasFeriasMesAtual = this.ultimasFeriasMesAtualValidation(row);
    const feriasConcorrentes = this.feriasConcorrentesValidation(row);

    const style = Object.assign(ultimasFeriasMesAtual, feriasConcorrentes);
    return style;
  }

  private updateRows(rows) {
    this.rows = rows;
  }

  private clearAlterableFields(row: any) {
    for (const column of this.grid.alterableFields) {
      row[column] = null;
    }
  }

  private async getLimiteProgFerias() {
    const valorReferencia = await CommonRequests.getValorReferencia(
      'QTDE_DIAS_ANTEC_FERIAS_PORTAL',
    );

    this.limiteDias = valorReferencia;
  }

  private async validateLimiteDiasProg(
    row: any,
  ) {
    const initialDate: string = row[this.columnsIndexes.dataInicialPrevisao];
    const dataAtual = DateUtil.getCurrentDate();

    const rowBackup = this.getBackupRow(row.NRFERIAS);

    const sameDateAsBackup = rowBackup ?
      initialDate === rowBackup[this.columnsIndexes.dataInicialPrevisao] :
      false;

    if (this.user.dp || !initialDate || !this.limiteDias || sameDateAsBackup) {
      return true;
    }

    const diff = DateUtil.differenceInDays(initialDate, dataAtual);
    const limiteDias = parseInt(this.limiteDias, 10);

    const valid = diff >= limiteDias;

    if (!valid) {
      const message = `As férias devem ser programadas com no mínimo ${limiteDias} dias de antecedência!`;
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ALERT);

      await Util.setTimeout(10);
      row[this.columnsIndexes.dataInicialPrevisao] = null;
    }

    return valid;
  }

  public afterReload(
    rows: any
  ) {
    this.backup = rows;
  }

  private getBackupRow(
    nrFerias: string
  ): any {
    const feriasRow = this.backup.find((row) => {
      return row.NRFERIAS === nrFerias;
    });

    return feriasRow;
  }
  // #endregion
}